import React, { useCallback } from "react";

import { useNewFormsServiceStore } from "@./state";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Icon from "apps/website/components/base/Icon/Icon";
import { ISummaryItem } from "@forms/schema";

export interface ISummaryFixedPriceRow {
  item: ISummaryItem,
  className: string,
  reloadSummary: () => void,
  flowSlug: string,
}

const SummaryFixedPriceRow = ({ item, className, reloadSummary, flowSlug }: ISummaryFixedPriceRow) => {
  const { setFlowFieldValue } = useNewFormsServiceStore();
  const setCatPlanRemoved = useCallback((catId: string | undefined, state: boolean) => {
    if (!catId) {
      console.error("Tried to remove item with no catId", { item });
      return;
    }
    setFlowFieldValue(flowSlug, "catPlanRemoved", {
      submitValue: state,
      displayValue: state,
    }, catId);
    reloadSummary();
  }, [ setFlowFieldValue, flowSlug, reloadSummary, item ]);

  return (
    <tr className={`h-auto ${className}`}>
      <th scope="row" colSpan={3} className="px-2 py-2 lg:py-2">
        <div className="flex flex-col justify-start items-start w-full gap-2">
          { item?.title?.value && (
            <div className="flex justify-start items-center w-full gap-2">
              <Icon icon={"tickInverted"} size="xsmall" color="success"/>
              <TextBody size={2}>
                { item?.title?.value }
              </TextBody>
            </div>
          ) }
          { item?.removalData && (item.removalData.planRemoved ? (
            <button onClick={() => setCatPlanRemoved(item?.removalData?.linkingId, false)}
              className="text-3xs text-green disabled:opacity-30 disabled:cursor-not-allowed min-w-fit underline text-center font-default opacity-100 lg:hover:opacity-70 transition-opacity duration-300">
              { item?.removalData?.addTitle }
            </button>
          ) : (
            <button onClick={() => setCatPlanRemoved(item?.removalData?.linkingId, true)}
              className="text-3xs text-red disabled:opacity-30 disabled:cursor-not-allowed min-w-fit underline text-center font-default opacity-100 lg:hover:opacity-70 transition-opacity duration-300">
              { item?.removalData?.removeTitle }
            </button>
          )) }
        </div>
      </th>
    </tr>
  );
};

export default SummaryFixedPriceRow;
